interface BrainSVGProps {
  color: string;
  style: React.CSSProperties;
}

const BrainSVG = ({ color, style }: BrainSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="63"
    height="52"
    viewBox="0 0 63 52"
    fill="none"
  >
    <g clipPath="url(#clip0_767_3047)">
      <path
        d="M17 10.5934L26.3203 1H46.915L62 16.5222V24.8585L56.858 30H48"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.19672 5.74921L9.80824 1.1377H15.8807"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.4808 22.1181H8.52726L3.95234 17.5432V12.1814"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.4922 31.4968L15.2371 34.2417H28.2757L39.9417 22.5757"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.7637 41.4336L44.3641 49.0341V58.1076"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M52.8277 39.5029L49.1678 43.1629V53.0752"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.686 22.899C44.3987 22.6219 45.5625 21.0089 45.2854 19.2962C45.0083 17.5835 43.3953 16.4197 41.6826 16.6968C39.9699 16.9739 38.8061 18.5869 39.0832 20.2996C39.3603 22.0123 40.9733 23.1761 42.686 22.899Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M55.6469 21.9842C57.3596 21.7071 58.5234 20.0941 58.2463 18.3814C57.9692 16.6687 56.3562 15.5049 54.6435 15.782C52.9308 16.0591 51.767 17.6721 52.044 19.3848C52.3211 21.0975 53.9342 22.2613 55.6469 21.9842Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2901 32.0214C12.0251 32.0214 13.4316 30.6149 13.4316 28.88C13.4316 27.145 12.0251 25.7385 10.2901 25.7385C8.55516 25.7385 7.14869 27.145 7.14869 28.88C7.14869 30.6149 8.55516 32.0214 10.2901 32.0214Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.9692 24.7853C29.3588 23.7465 29.6431 21.7779 28.6043 20.3883C27.5655 18.9987 25.5969 18.7143 24.2073 19.7531C22.8177 20.7919 22.5333 22.7605 23.5721 24.1501C24.6109 25.5397 26.5795 25.8241 27.9692 24.7853Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.14144 11.913C5.87641 11.913 7.28289 10.5065 7.28289 8.77157C7.28289 7.0366 5.87641 5.63013 4.14144 5.63013C2.40647 5.63013 1 7.0366 1 8.77157C1 10.5065 2.40647 11.913 4.14144 11.913Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.6956 32.4007C48.0821 31.3578 48.3607 29.3883 47.3178 28.0018C46.2748 26.6153 44.3054 26.3368 42.9189 27.3797C41.5323 28.4226 41.2538 30.3921 42.2967 31.7786C43.3396 33.1651 45.3091 33.4436 46.6956 32.4007Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.6365 41.5523C38.0194 40.5046 38.291 38.5342 37.2433 37.1513C36.1955 35.7684 34.2251 35.4968 32.8422 36.5445C31.4594 37.5923 31.1877 39.5627 32.2354 40.9456C33.2832 42.3284 35.2536 42.6001 36.6365 41.5523Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M56.919 39.5653C58.3026 38.5185 58.5757 36.5483 57.5289 35.1647C56.4821 33.7811 54.5119 33.508 53.1283 34.5548C51.7446 35.6016 51.4716 37.5718 52.5184 38.9554C53.5652 40.339 55.5354 40.6121 56.919 39.5653Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4678 16.0503C17.1695 15.7121 18.2748 14.0585 17.9367 12.3568C17.5985 10.6551 15.9448 9.54974 14.2432 9.88792C12.5415 10.2261 11.4361 11.8797 11.7743 13.5814C12.1125 15.2831 13.7661 16.3885 15.4678 16.0503Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.4438 13.1667C39.1788 13.1667 40.5852 11.7602 40.5852 10.0252C40.5852 8.29026 39.1788 6.88379 37.4438 6.88379C35.7088 6.88379 34.3023 8.29026 34.3023 10.0252C34.3023 11.7602 35.7088 13.1667 37.4438 13.1667Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.7495 14.8289L28.4617 10.1167H34.1712"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.3622 10.0955L53.3615 16.0947"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.8033 36.7061V41.6897"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3115 29.1851H22.9871"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_767_3047">
        <rect
          width="63.57"
          height="58.87"
          fill={color}
          transform="translate(-0.570007)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default BrainSVG;
